// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import translate from "@insite/client-framework/Translate";
import { DynamicDropdownPresentationProps } from "@insite/mobius/DynamicDropdown";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import updateDraftParameter from "@store/Framework/Store/Greif/Pages/OrderHistory/Handlers/UpdateDraftParameter";
import { useOrderHistoryState } from "@store/Framework/Store/Greif/Pages/OrderHistory/OrderHistoryHooks";
import { useFilterDrawerContext } from "@store/Library/Components/FilterDrawerAndButton";
import FilterDrawerSection from "@store/Library/Components/FilterDrawerSection";
import SearchShipToField from "@store/Library/Components/SearchShipToField";
import { filterDrawerProps } from "@store/Themes/common/props/filterDrawer";
import React, { FC, useMemo } from "react";

export interface OrderHistoryFilterFieldShipToProps {}

export interface OrderHistoryFilterFieldShipToStyles {
    searchShipToField?: DynamicDropdownPresentationProps;
}

export const OrderHistoryFilterFieldShipToStyles: OrderHistoryFilterFieldShipToStyles = {
    searchShipToField: filterDrawerProps.dynamicDropdown,
};

const styles = OrderHistoryFilterFieldShipToStyles;

const OrderHistoryFilterFieldShipTo: FC<OrderHistoryFilterFieldShipToProps> = () => {
    const dispatch = useAppDispatch();
    const { scrollElement } = useFilterDrawerContext();
    const { customerSequence } = useOrderHistoryState().draftParameter;
    const id = useMemo(uniqueId, []);

    return (
        <FilterDrawerSection title={translate("Ship To")} labelFor={id}>
            <SearchShipToField
                {...styles.searchShipToField}
                data-test-selector="orderHistory_filterShipTo"
                onSelectionChange={customerSequence => {
                    dispatch(updateDraftParameter({ customerSequence }));
                }}
                placeholder={translate("Search or Select Ship To")}
                scrollElement={scrollElement}
                selected={customerSequence}
                uid={id}
            />
        </FilterDrawerSection>
    );
};

export default OrderHistoryFilterFieldShipTo;
